<lib-modal-header (close)="close$.emit()">
  {{ "modals.confirm.title" | translate }}
</lib-modal-header>

<lib-modal-body>
  <main>
    {{ message }}
  </main>
</lib-modal-body>

<lib-modal-footer class="footer" style="justify-content: center;">
  <button #closeButton (click)="confirm()" libButton [appearance]="'primary'">
    {{ "actions.ok" | translate }}
  </button>
</lib-modal-footer>
